import styled from 'styled-components';
import { white, black, grey400, brandColors } from 'styles/colors';
import { appHeaderHeight, appSideSpacing } from 'styles/spacings';

export const Header = styled.header`
	display: flex;
	align-items: center;
	height: ${appHeaderHeight};
	padding: 0 ${appSideSpacing};
	background-color: ${black};
	color: ${white};
`;

export const ClientName = styled.h1`
	font-size: 16px;
	border-left: 1px solid ${brandColors.green};
	color: ${white};
	margin: 0 12px;
	padding-left: 12px;
	line-height: 24px;
`;
export const HeaderWrapper = styled.div`
	div > div > a:first-of-type {
		display: none;
	}
`;
export const LogoWrapper = styled.div`
	display: flex;
	color: ${grey400};
	align-items: center;
`;

export const Main = styled.main`
	height: calc(100% - ${appHeaderHeight});
	min-width: 1024px;
	background-color: ${white};
	position: relative;
	z-index: 0;
`;
export const HeaderTitle = styled.div`
	font-size: 17px;
`;
